import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { BlockedProduct, ProductV2Dto } from '../interfaces/product-interface';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  PRODUCT_ROUTE_API = 'api/{version}/products';
  PRODUCT_MOTIF_RESILIATION = 'api/v1.0/products/{ProductId}/motifsresiliation';
  PRODUCT_DEMANDE_RESILIATION = 'api/v1.0/domains/products/askresiliation';
  PRODUCT_CANCEL_RESILIATION = 'api/v1.0/domains/products/cancelresiliation';
  PRODUCT_ROUTE_API_COMMAND = 'api-public/v2.0/shop/products';

  PRODUCTS_STORAGE_KEY = 'Products';

  public products$: BehaviorSubject<ProductV2Dto[]> = new BehaviorSubject<ProductV2Dto[]>([]);

  public get products(): Observable<ProductV2Dto[] | null> {
    return this.products$.asObservable();
  }

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigurationService,
  ) {}

  public getProductsV2(): Observable<ProductV2Dto[]> {
    return this.httpClient
      .get<
        ProductV2Dto[]
      >(`${this.configService.urlApiSiVision}/${this.PRODUCT_ROUTE_API}`.replace('{version}', 'v2.0'))
      .pipe(
        tap((products) => {
          this.products$.next(products);
          this.setProductSessionStorage(products);
        }),
      );
  }

  public setProductSessionStorage(products: ProductV2Dto[]) {
    sessionStorage.setItem(this.PRODUCTS_STORAGE_KEY, JSON.stringify(products));
  }

  public getReasonForCancellation(productId: string): Observable<Array<ReasonForCancellation>> {
    return this.httpClient.get<Array<ReasonForCancellation>>(
      `${this.configService.urlApiSiVision}/${this.PRODUCT_MOTIF_RESILIATION}?onlyFirstLevel=true`.replace(
        '{ProductId}',
        productId,
      ),
    );
  }

  public getProductsWithPrices(periodicity: string): Observable<ProductCommand[]> {
    return this.httpClient.get<ProductCommand[]>(
      `${this.configService.urlApiMsOrder}/${this.PRODUCT_ROUTE_API_COMMAND}?Periodicity=${periodicity}`,
    );
  }

  public getBlockedProduct(domainId: string, productId: string): Observable<BlockedProduct> {
    return this.httpClient.get<BlockedProduct>(
      `${this.configService.urlApiSiVision}/api/v2.0/${domainId}/BlockedProducts/${productId}`,
    );
  }
}

export interface ProductCommand {
  id: string;
  codeEcc: string;
  codeHubbix: number;
  name: string;
  finalPriceAmount: number;
  originPriceAmount: number;
  discountAmount: number;
  isPlatform: boolean;
  isSoftware: boolean;
  isOption: boolean;
  isTraining: boolean;
}

export interface ReasonForCancellation {
  id: string;
  libelle: string;
  parentId?: string;
}
